import React, { useContext } from "react";
import PropTypes from "prop-types";
import Popup from "~/assets/js/components/Popup";
import { ForwardButton } from "~/assets/js/components/Button";
import i18n from "~/assets/js/Helpers/i18n";
import useAreaCookie from "~/assets/js/Helpers/hooks/useAreaCookie";
import { unpackAreaCookie } from "~/assets/js/Format";
import TimeSlotSelectInfo from "~/assets/js/pages/Checkout/sections/TimeSlotSelect/TimeSlotSelectInfo.js";
import Timeslot from "~/assets/js/components/Timeslot";
import isEmpty from "lodash.isempty";
import {
    CheckoutContext,
    ACTIONS,
} from "~/assets/js/pages/Checkout/CheckoutProvider";
import { useCartContext } from "~/assets/js/global/cartContext";
import { formatDate } from "../../pages/Checkout/sections/TimeSlotSelect/formatDateTime";
import EarlyOnLocationToggle from "../../pages/Checkout/sections/TimeSlotSelect/EarlyOnLocationToggle";

const FastCheckoutTimeSlot = ({ state, setState }) => {
    const { actions } = useCartContext();
    const cookie = useAreaCookie();
    const cookieContent = unpackAreaCookie(cookie);
    const { dispatch } = useContext(CheckoutContext);
    const isDelivery = cookie?.area?.type === "delivery";

    const timeSelectClose = () => {
        setState({ ...state, timeSelectOpen: false });
    };

    const popupConfig = {
        title: cookieContent.isDelivery
            ? i18n.t("timeSlotSelect.deliveryTitle")
            : i18n.t("timeSlotSelect.pickupTitle"),
        subtitle:
            state.selectedDay && state.selectedDay[0]
                ? `${
                      formatDate(state.selectedDay[0].deliveryDay).append
                  }, den ${formatDate(state.selectedDay[0].deliveryDay).date}`
                : "",
        handleClose: timeSelectClose,
        handleInfo: openInfo,
        open: state.timeSelectOpen,
        isClosable: true,
        isInfo: false,
    };

    const popupConfigDelivery = {
        open: state.earlyOnLocationOpen,
        isClosable: true,
        handleClose: EarlyOnLocationClose,
    };

    const openInfo = () => {
        setState({ ...state, timeSelectInfoOpen: true });
    };

    const closeInfo = () => {
        setState({ ...state, timeSelectInfoOpen: false });
    };

    const onTimeSlotSelect = (timeSlot) => {
        setState({ ...state, selectedTime: timeSlot });
    };

    const EarlyOnLocationClose = () => {
        setState({ ...state, earlyOnLocationOpen: false });
    };

    const applyTimeSlot = async (timeSlot) => {
        setState({ ...state, isLoading: true });
        await actions.updateTimeSlot(timeSlot);

        dispatch({
            type: ACTIONS.ADD_TIME_SLOT,
            payload: timeSlot,
        });

        const selectedDay = state.groupedDeliveryTimes[timeSlot.deliveryDay];

        setState({
            ...state,
            timeSelectOpen: false,
            isLoading: false,
            selectedDay: selectedDay,
            earlyOnLocationOpen: cookieContent.isDelivery,
        });
    };

    return (
        <>
            <Popup {...popupConfig}>
                <div className="timeslot__container">
                    <TimeSlotSelectInfo
                        open={state.timeSelectInfoOpen}
                        handleClose={closeInfo}
                    />

                    {!!state.firstAvailable && (
                        <Timeslot
                            isFirst={true}
                            isFirstContent={
                                isDelivery
                                    ? i18n.t("timeSlotSelect.earliestDelivery")
                                    : i18n.t("timeSlotSelect.earliestPickup")
                            }
                            time={state.firstAvailable}
                            availability={state.firstAvailable.capacity}
                            onValueChange={() =>
                                onTimeSlotSelect(state.firstAvailable)
                            }
                            defaultValue={state.selectedTime}
                        />
                    )}

                    {!!(state.selectedDay && state.selectedDay.length) &&
                        state.selectedDay.map((timeSlot, i) => {
                            return (
                                <Timeslot
                                    time={timeSlot}
                                    availability={timeSlot.capacity}
                                    onValueChange={() =>
                                        onTimeSlotSelect(timeSlot)
                                    }
                                    key={i}
                                    defaultValue={state.selectedTime}
                                />
                            );
                        })}
                </div>
                <div className="timeslot_button__container">
                    <ForwardButton
                        label={i18n.t("cart.continue")}
                        size="SM"
                        customStyle="timeslot_button"
                        onClick={() => {
                            applyTimeSlot(state.selectedTime);
                        }}
                        loading={state.isLoading}
                        variant="secondary"
                        disabled={isEmpty(state.selectedTime)}
                    />
                </div>
            </Popup>
            {isDelivery && (
                <Popup {...popupConfigDelivery}>
                    <EarlyOnLocationToggle
                        open={state.earlyOnLocationOpen}
                        handleClose={EarlyOnLocationClose}
                        deliveryDate={
                            state.selectedDay && state.selectedDay[0]
                                ? `${
                                      formatDate(
                                          state.selectedDay[0].deliveryDay
                                      ).append
                                  }, den ${
                                      formatDate(
                                          state.selectedDay[0].deliveryDay
                                      ).date
                                  }`
                                : ""
                        }
                    />
                </Popup>
            )}
        </>
    );
};

FastCheckoutTimeSlot.propTypes = {
    setState: PropTypes.func,
    state: PropTypes.shape({
        isLoading: PropTypes.bool,
        groupedDeliveryTimes: PropTypes.object,
        selectedDay: PropTypes.array,
        firstAvailable: PropTypes.object,
        timeSelectOpen: PropTypes.bool,
        earlyOnLocationOpen: PropTypes.bool,
        timeSelectInfoOpen: PropTypes.bool,
        notification: PropTypes.bool,
        selectedTime: PropTypes.instanceOf(Date),
    }),
};

export default FastCheckoutTimeSlot;
